export default class CalculateReadingTime {
	constructor() {
		this.contentWrapper = document.querySelector('[data-content-longread]');

		if(!this.contentWrapper) {
			return;
		}

		this.readingTime();
    }

	readingTime() {
		const text = this.contentWrapper.innerText;
		const wpm = 225;
		const words = text.trim().split(/\s+/).length;
		const time = Math.ceil(words / wpm);
		document.getElementById("time").innerText = time;
	}
}
